import React, { useState } from "react";
import { rootUrl, userKey } from "../../App";
import { useDispatch } from "react-redux";
import {
    setInnerLoaderFalse,
    setInnerLoaderTrue,
} from "../../Redux/loaderSlice";
import { showCustomSweetAlert } from "../../Redux/customSweetAlertSlice";
import { fetchLoginUserWallet, fetchLogoutUser } from "../../Redux/userSlice";
import { useNavigate } from "react-router-dom";
import { useThemeColor } from "../../hooks/useThemeColor";

const BonusModal = ({ bonusBanner, onClose }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { colorMode } = useThemeColor();
    const [activeIndex, setActiveIndex] = useState(0);

    const claimBonusCheck = (item) => {
        let sendData = {
            claim_bonus_id: item?.id,
        };
        if (item?.id) {
            dispatch(setInnerLoaderTrue());
            let stringValue = localStorage.getItem(userKey);
            if (stringValue !== null) {
                let value = JSON.parse(stringValue);
                fetch(`${rootUrl}/wallet/add-claim-bonus/`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${value?.value}`,
                    },
                    body: JSON.stringify(sendData),
                })
                    .then((res) => {
                        if (!res.ok) throw res;
                        else return res.json();
                    })
                    .then((data) => {
                        if (data?.status === "ok") {
                            dispatch(
                                showCustomSweetAlert({
                                    type: "success",
                                    message: `${data?.message}`,
                                })
                            );
                            dispatch(fetchLoginUserWallet());
                        }
                        if (data?.status === "failed") {
                            dispatch(
                                showCustomSweetAlert({
                                    type: "error",
                                    message: `${data?.errors}`,
                                })
                            );
                            dispatch(setInnerLoaderFalse());
                            return;
                        }
                    })
                    .catch((err) => {
                        err.json().then((text) => {
                            if (text?.error) {
                                dispatch(
                                    showCustomSweetAlert({
                                        type: "error",
                                        message: `${text?.error}`,
                                    })
                                );
                                return;
                            }
                            if (text?.detail === "Invalid token.") {
                                dispatch(fetchLogoutUser());
                                return;
                            }
                        });
                        dispatch(
                            showCustomSweetAlert({
                                type: "error",
                                message: `${err?.statusText}`,
                            })
                        );
                    })
                    .finally(() => {
                        dispatch(setInnerLoaderFalse());
                    });
            } else {
                onClose();
                navigate("/login");
            }
        }
    };

    const handlePrev = () => {
        setActiveIndex((prev) =>
            prev === 0 ? bonusBanner.length - 1 : prev - 1
        );
    };

    const handleNext = () => {
        setActiveIndex((prev) =>
            prev === bonusBanner.length - 1 ? 0 : prev + 1
        );
    };

    const activeItem = bonusBanner[activeIndex];

    return (
        <div
            className="position-fixed top-0 start-0 w-100 d-flex align-items-center justify-content-center"
            style={{
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                height: "100dvh",
                maxHeight: "100dvh",
                zIndex: 1050,
            }}
        >
            {/* Modal Box */}
            <div className="px-0 position-relative" style={{ maxWidth: "90%" }}>
                {/* Close Button */}
                <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0 m-0"
                    onClick={onClose}
                    style={{
                        backgroundColor: "var(--golden)",
                    }}
                ></button>

                {/* Modal Content */}
                <div className="text-center">
                    <img
                        src={rootUrl + activeItem?.image}
                        alt="Promo"
                        className="img-fluid mb-3"
                    />
                    <p className="fw-bold"
                        style={{
                            color: (colorMode === "light") ? "var(--white)" : "var(--white)",
                        }}
                    >{activeItem?.name}</p>
                    <button
                        className="btn btn-sm btn-danger w-75 py-2 py-md-3 fw-bold"
                        onClick={() => claimBonusCheck(activeItem)}
                    >
                        {activeItem?.alt_text}
                    </button>

                    {/* Slider Controls (only if more than 1) */}
                    {bonusBanner?.length > 1 && (
                        <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                            <button
                                className="btn btn-outline-light rounded-circle"
                                onClick={handlePrev}
                            >
                                ←
                            </button>
                            {/* Dot Indicators */}
                            <div className="d-flex gap-1">
                                {bonusBanner.map((_, i) => (
                                    <span
                                        key={i}
                                        style={{
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            display: "inline-block",
                                            backgroundColor: i === activeIndex ? "var(--golden)" : "#aaa",
                                        }}
                                    ></span>
                                ))}
                            </div>
                            <button
                                className="btn btn-outline-light rounded-circle"
                                onClick={handleNext}
                            >
                                →
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BonusModal;